var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6096_18322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3309 11.2099H12.7909V6.66988C12.7909 6.22988 12.4409 5.87988 12.0009 5.87988C11.5609 5.87988 11.2109 6.22988 11.2109 6.66988V11.2099H6.67086C6.23086 11.2099 5.88086 11.5599 5.88086 11.9999C5.88086 12.4399 6.23086 12.7899 6.67086 12.7899H11.2109V17.3299C11.2109 17.7699 11.5609 18.1199 12.0009 18.1199C12.4409 18.1199 12.7909 17.7699 12.7909 17.3299V12.7899H17.3309C17.7709 12.7899 18.1209 12.4399 18.1209 11.9999C18.1209 11.5599 17.7709 11.2099 17.3309 11.2099Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM22.33 12C22.33 17.7 17.69 22.33 12 22.33C6.31 22.33 1.67 17.7 1.67 12C1.67 6.3 6.3 1.67 12 1.67C17.7 1.67 22.33 6.31 22.33 12Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6096_18322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/createIcon.303956b54dd8841505070c3cea769ac3.svg";
export { ForwardRef as ReactComponent };